// extracted by mini-css-extract-plugin
export const blogPostListTitle = "blog-post-list-row-module--blogPostListTitle--3CFCx";
export const blogPostList = "blog-post-list-row-module--blogPostList--2uy2d";
export const preview = "blog-post-list-row-module--preview--2qD5L";
export const blogPostLink = "blog-post-list-row-module--blogPostLink--27DBQ";
export const imageWrapper = "blog-post-list-row-module--imageWrapper--1qHwy";
export const tagList = "blog-post-list-row-module--tagList--2jLMN";
export const infoContainer = "blog-post-list-row-module--infoContainer--1HZ92";
export const title = "blog-post-list-row-module--title--33_Te";